import {Balikovna} from "./pickup-points/balikovna";
import {GlsParcelshop} from "./pickup-points/gls-parcelshop";

class CheckoutMethods {

	constructor() {
		// Init pickup points if needed
		this.init_pickup_points()

		// Init form
		this.init_form()
	}

	init_form() {

		let _this = this

		jQuery(document).gp_ready(function () {

			// Init form change AJAX update
			jQuery("form#checkout-methods-form").gp_on('change', _this.update_methods)

			// Init location pickup change update
			jQuery("form#checkout-location-pickup").gp_on('change', function () {
				jQuery(document).trigger('close_modal')
				return _this.update_methods.apply(this, arguments)
			})

			// Init pickup points
			jQuery("[data-select-pickup-point]").gp_on('click', function () {
				let method_type = jQuery(this).data("select-pickup-point")
				_this.select_pickup_point(method_type)
			})

			// Hide Apple Pay if not supported by browser
			_this.maybe_hide_apple_pay()
		})
	}

	init_pickup_points() {

		// Define pickup points
		this.balikovna = new Balikovna()
		this.gls_parcelshop = new GlsParcelshop()

		// Some methods need to init first
		this.balikovna.init()
		this.gls_parcelshop.init()
	}

	select_pickup_point(method_type) {
		switch (method_type) {
			case 'balikovna_pick_up_point':
				this.balikovna.open_pickup()
				break;
			case 'gls_parcelshop':
				this.gls_parcelshop.open_pickup()
				break;
			default:
				// Do nothing
				break;
		}
	}

	maybe_hide_apple_pay() {
		if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
			let $apple_pay_input = jQuery('input[name="payment_method_id"][value*="apple_pay"]')
			if ($apple_pay_input.is(':checked')) {
				$apple_pay_input.prop('checked', false)
			}

			$apple_pay_input.closest('.checkout-method-radio').hide()
		}
	}

	update_methods(e) {
		if (jQuery(e.target).is('[name="shipping_method_id"][value="location"]')) { // do not update, just open sidebar
			return;
		}

		let url = ghostpress_params.ajax_url + "&action=cart_update_methods",
			data = jQuery(this).serializeArray()

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
	}

}

new CheckoutMethods()
